import { FormulaEquation } from '../../types';

export const MATH_EQUATIONS: FormulaEquation[] = [
  // --- MATEMÁTICA: FUNÇÃO QUADRÁTICA ---
  {
    id: 'vertice_xv',
    name: 'Abscissa do Vértice (Xv)',
    subject: 'MATEMATICA',
    latex: 'X_v = -\\frac{b}{2a}',
    variables: ['Xv', 'a_quad', 'b_quad'],
    description: 'Eixo de simetria e coordenada horizontal do ponto de máximo ou mínimo da parábola.',
    rearrangedLatex: {
      Xv: 'X_v = -\\frac{b}{2a}',
      b_quad: 'b = -2a X_v',
      a_quad: 'a = -\\frac{b}{2X_v}',
    },
    descriptorCode: 'MAT_D27',
  },
  {
    id: 'vertice_yv',
    name: 'Ordenada do Vértice (Yv - Valor Extremo)',
    subject: 'MATEMATICA',
    latex: 'Y_v = -\\frac{\\Delta}{4a}',
    variables: ['Yv', 'delta_quad', 'a_quad'],
    description: 'Valor máximo ou mínimo assumido pela imagem da função quadrática.',
    rearrangedLatex: {
      Yv: 'Y_v = -\\frac{\\Delta}{4a}',
      delta_quad: '\\Delta = -4a Y_v',
      a_quad: 'a = -\\frac{\\Delta}{4Y_v}',
    },
    descriptorCode: 'MAT_D27',
  },
  {
    id: 'discriminante_delta',
    name: 'Discriminante Quadrático (Delta)',
    subject: 'MATEMATICA',
    latex: '\\Delta = b^2 - 4ac',
    variables: ['delta_quad', 'a_quad', 'b_quad', 'c_quad'],
    description: 'Discriminante que define se a equação do 2º grau tem 2, 1 ou nenhuma raiz real.',
    rearrangedLatex: {
      delta_quad: '\\Delta = b^2 - 4ac',
      c_quad: 'c = \\frac{b^2 - \\Delta}{4a}',
      a_quad: 'a = \\frac{b^2 - \\Delta}{4c}',
      b_quad: 'b = \\pm \\sqrt{\\Delta + 4ac}',
    },
    descriptorCode: 'MAT_D20',
  },

  // --- MATEMÁTICA: GEOMETRIA ---
  {
    id: 'area_circulo',
    name: 'Área do Círculo',
    subject: 'MATEMATICA',
    latex: 'A = \\pi r^2',
    variables: ['A_circ', 'r_circ'],
    description: 'Área delimitada pela circunferência de raio r.',
    rearrangedLatex: {
      A_circ: 'A = \\pi r^2',
      r_circ: 'r = \\sqrt{\\frac{A}{\\pi}}',
    },
    descriptorCode: 'MAT_D10',
  },
  {
    id: 'comp_circunferencia',
    name: 'Comprimento da Circunferência',
    subject: 'MATEMATICA',
    latex: 'C = 2\\pi r',
    variables: ['C_circ', 'r_circ'],
    description: 'Perímetro linear do contorno circular de raio r.',
    rearrangedLatex: {
      C_circ: 'C = 2\\pi r',
      r_circ: 'r = \\frac{C}{2\\pi}',
    },
    descriptorCode: 'MAT_D10',
    alternateDescriptorCodes: ['MAT_D14'],
  },
  {
    id: 'teorema_pitagoras',
    name: 'Teorema de Pitágoras',
    subject: 'MATEMATICA',
    latex: 'a_{hip}^2 = b_{cat}^2 + c_{cat}^2',
    variables: ['hipotenusa', 'cateto_b', 'cateto_c'],
    description: 'Em triângulo retângulo, o quadrado da hipotenusa é a soma dos quadrados dos catetos.',
    rearrangedLatex: {
      hipotenusa: 'a_{hip} = \\sqrt{b_{cat}^2 + c_{cat}^2}',
      cateto_b: 'b_{cat} = \\sqrt{a_{hip}^2 - c_{cat}^2}',
      cateto_c: 'c_{cat} = \\sqrt{a_{hip}^2 - b_{cat}^2}',
    },
    descriptorCode: 'MAT_D2',
  },
  {
    id: 'area_triangulo',
    name: 'Área do Triângulo',
    subject: 'MATEMATICA',
    latex: 'A = \\frac{b \\cdot h}{2}',
    variables: ['A_triang', 'b_triang', 'h_triang'],
    description: 'Área do triângulo dada pelo semiproduto da base pela altura.',
    rearrangedLatex: {
      A_triang: 'A = \\frac{b \\cdot h}{2}',
      b_triang: 'b = \\frac{2A}{h}',
      h_triang: 'h = \\frac{2A}{b}',
    },
    descriptorCode: 'MAT_D10',
  },
];
